import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController, AlertController, LoadingController, App, Events } from 'ionic-angular';
import { HttpService } from '../../services/HttpService';
import { DomSanitizer } from '@angular/platform-browser';

import { LoginPage } from '../login/login';
import { NotifipopupPage } from '../notifipopup/notifipopup';
import { NotificationPage } from '../notification/notification';
import { NotifimodalPage } from '../notifimodal/notifimodal';
import { CashroomPage } from '../cashroom/cashroom';
import { BonusroomPage } from '../bonusroom/bonusroom';
import { BonuslistPage } from '../bonuslist/bonuslist';
import { MygroupPage } from '../mygroup/mygroup';
import { StakingPage } from '../staking/staking';
import { StakinglistPage } from '../stakinglist/stakinglist';
import { CountdownPage } from '../countdown/countdown';
import { MultiregistPage } from '../multiregist/multiregist';
import { DbclistPage } from '../dbclist/dbclist';
import { AvatalistPage } from '../avatalist/avatalist';
import { MyactivePage } from '../myactive/myactive';
import { ActivepopupPage } from '../activepopup/activepopup';
import { ActivedepositPage } from '../activedeposit/activedeposit';
import { ActiveconfirmPage } from '../activeconfirm/activeconfirm';
import { InAppBrowser, InAppBrowserObject } from '@ionic-native/in-app-browser';

declare var Highcharts : any;

/**
 * Generated class for the WalletPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
    selector: 'page-wallet',
    templateUrl: 'wallet.html',
})
export class WalletPage {

    // vid = "https://www.youtube.com/embed/cnQVk7hFzHI";

	rootPage: any;
	// user_id: string;
	// user_name: string;
	email: string;
	office_email: string;
	invite: string;
	company: string;
	
	loginId: string;
    api_key: string;
    version: string;

    coin_unit: string;
    coin_name: string;
    unit: string;
    btc_unit: string;
    usdt_unit: string;
    point_unit: string;

    // cash_room_unit: string;
    // bonus_room_unit: string;

    chucheon_r_url: string;
    chucheon_1_url: string;
    
    servermode: string;
    deposit: string;
    address: string;
    date_mining: string;
    count_mining: string;
    count_chucheon: string;
    conversion_rate: string;
    rank: string;

    inweb_url: string;
    
    // member_count: any;
    sum_deposit: any = [];
    sum_chucheon: any = [];
    chart: any = [];
    member: any = [];
    chucheon: any = [];
    banner: any = [];
    // rank: any = [];
    // level: any = [];
    // daily: any = [];
    // rate: any = [];
    button: any = [];
    link: any = [];
    roulette: any = [];

    // chucheon: any = [];

    // balance_point_parts01: string;
    // balance_point_parts02: string;

    // staking_value: string;
    // staking_interest: string;
    // staking_list: any = [];

    // bonus_name: any = [];
    // bonus_value_one_coin: any = [];
    // bonus_value_two_coin: any = [];
    // bonus_list_one: any = [];
    // bonus_list_two: any = [];

    // withdraw_list: any = [];

    // ticker: any = [];

	notice: any = [];

    badges: string;
    
    texts: any = [];
    activeTexts: any = [];
    activeHasHistory: boolean = false;
    language: string;

    // 2026-08-26 PDF p.4 - 로그인 후 Active 안내 팝업.
    // config/dashboard 가 내려주는 값 (2026-08-27 백엔드 확정):
    //   active_popup         : 'N'(안 띄움) | 'A'(신청, 차감 가능)
    //                          | 'D'(신청, 차감 불가) | 'R'(갱신 차감 실패)
    //   active_popup_address : 입금 팝업(p.8, p.9)에 띄울 주소
    //   active_popup_amount  : 입금 팝업에 띄울 Deposit Amount
    // 서버가 아직 이 필드를 안 보내면 팝업은 뜨지 않는다(= 기존 동작 그대로).
    activePopup: string = '';
    activeDeposit: any = {};
    activePopupShown: boolean = false;

    // 2026-09-18 PDF p.2~p.3 - 입금액에 따른 회원 명칭 배지.
    // config/dashboard 가 내려주는 값:
    //   appellation : MEMBER | STARTER | PRO | VIP | BUSINESS | AMBASSADOR | FOUNDER
    // 서버가 아직 이 필드를 안 보내면 배지는 안 그린다(= 기존 화면 그대로).
    // active_popup 때와 같은 방어 방식이다.
    appellation: string = '';
    appellationImg: string = '';

    //// 명칭 -> 배지 이미지. 서버가 대소문자를 어떻게 보낼지 확실치 않아 대문자로 맞춰 찾는다.
    //// 모르는 값이 오면 '' 라서 배지가 안 나온다(엉뚱한 배지를 띄우는 것보다 낫다).
    static readonly APPELLATION_IMGS = {
        'MEMBER'     : 'assets/imgs/level_01.png',
        'STARTER'    : 'assets/imgs/level_02.png',
        'PRO'        : 'assets/imgs/level_03.png',
        'VIP'        : 'assets/imgs/level_04.png',
        'BUSINESS'   : 'assets/imgs/level_05.png',
        'AMBASSADOR' : 'assets/imgs/level_06.png',
        'FOUNDER'    : 'assets/imgs/level_07.png'
    };

    opened: boolean = false;
  
	constructor(
		public navCtrl: NavController,
		public navParams: NavParams,
		public modalCtrl: ModalController,
		public alertCtrl: AlertController,
        public loadingCtrl: LoadingController,
        private iab: InAppBrowser,
        private dom: DomSanitizer,
		private http: HttpService,
		public app: App,
		public events: Events
	) {
		

    }
    
    ionViewWillEnter() {

		//// 로그인이 안되어 있다면 로그인 화면으로 이동한다.
		this.api_key = localStorage.getItem("api_key");
		this.loginId = localStorage.getItem("loginId");
		if(!this.api_key) {
			this.app.getRootNav().setRoot(LoginPage);
		}

		//// 페이지 이름
        localStorage.setItem("pageName", "wallet");
        this.language = localStorage.getItem("language");
        this.email = localStorage.getItem("email");
        this.version = localStorage.getItem("version");
        this.invite = localStorage.getItem("invite");
        this.office_email = localStorage.getItem("office_email");
        this.company = localStorage.getItem("company");
        this.point_unit = localStorage.getItem("point_unit");
        this.btc_unit = localStorage.getItem("btc_unit");
        this.usdt_unit = localStorage.getItem("usdt_unit");
        this.coin_unit = localStorage.getItem("coin_unit");
        this.coin_name = localStorage.getItem("coin_name");
        this.unit = localStorage.getItem("unit");
        this.servermode = localStorage.getItem("servermode");
        // this.chucheon_base_url = localStorage.getItem("chucheon_base_url");
        // this.test_chucheon_base_url = localStorage.getItem("test_chucheon_base_url");
        // this.line_base_url = localStorage.getItem("line_base_url");
        // this.test_line_base_url = localStorage.getItem("test_line_base_url");
		// this.cash_room_unit = localStorage.getItem("cash_room_unit");
		// this.bonus_room_unit = localStorage.getItem("bonus_room_unit");

        this._get_texts();
        // this._bonus_progress();

        // this.chucheon_url = "http://btcxclub.ddsapp.net/tree/huwon/" + this.api_key

        this._init().then((res: any) => {
            this._chart_rate(res);
            this._active_popup();

            // if (res != undefined) {

            //     if (res.chart != undefined) {   
            //         this._chart_rate(res.chart);
            //         // this.today_rate = res.rate_value;
            //     }
            // }
		});
        // this._web_chucheon();
        // this._web_line();
        
		// this._init();

		// this._jquery();
		// this.interval();
		
		// this.events.subscribe('init', init => {
		// 	this._init();
		// })
	}

	ionViewDidLoad() {
		this._once();
	}

	_get_texts() {
		this.texts = JSON.parse(localStorage.getItem('lang_pack')).wallet;
		this.texts.btn_title = 'Rewards';
		this.texts.conversion = 'Ratio';
		this.activeTexts = JSON.parse(localStorage.getItem('lang_pack')).active || {};
	}
	
	_once() {
		if (this.api_key == '' || this.api_key == undefined || this.api_key == null) {
			this.api_key = localStorage.getItem("api_key");
		}
		this.loginId = localStorage.getItem("loginId");
		this.language = localStorage.getItem("language");
		this.version = localStorage.getItem("version");

		let url = "info/notice/index/after";
		let body = JSON.stringify({ 
			api: this.api_key,
            language: this.language,
            version: this.version
		});
		this.http.post(url, body).then((res: any) => {
			if(res.result=="OK"){
                this.badges = res.badges;
				if (res.list == undefined) {
					
				} else {
					let modal = this.modalCtrl.create(NotifipopupPage, {list: res.list});
					modal.present();
					modal.onDidDismiss( idx => {
						if(idx == "" || idx == undefined || idx == null) {
							
						} else {              
							let url = "info/notice/index/save";
							let body = JSON.stringify({ 
								api: this.api_key,
								language: this.language,
								version: this.version,
								idx: idx
							});
							this.http.post(url, body).then((res: any) => {
								if(res.result=="OK"){
									this._once();
                                    if (this.badges != undefined) this._init();

								} else {
									let alert = this.alertCtrl.create({
										message: res.message,
										buttons: ['OK']
									});
									alert.present();
								}
								
							},(err)=>{	
								//// HTTP 에러인 경우
								let alert = this.alertCtrl.create({
									message: this.texts.alertM_err,
									buttons: ['OK']
								});
								alert.present();
							
							});
						}
					});
				}
				
				
			} else if(res.result ==="LOGOUT"){
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
				localStorage.removeItem("loginId");
				localStorage.removeItem("api_key");
				this.app.getRootNav().setRoot(LoginPage);
			
			} else {
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
			}
			
		},(err)=>{	
			//// HTTP 에러인 경우
			let alert = this.alertCtrl.create({
				message: this.texts.alertM_err,
				buttons: ['OK']
			});
			alert.present();
		
		});
	}

	_init() {
        // let loader = this.loadingCtrl.create({
        //     content: "loading..."
        // });
        // loader.present();

        return new Promise((resolve,reject)=>{
            let url = "config/dashboard";
            let body = JSON.stringify({ 
                api: this.api_key,
                language: this.language,
                version: this.version
            });
            this.http.post(url, body).then((res: any) => {
                if(res.result=="OK"){
                    this.sum_deposit = res.sum_deposit;
                    this.date_mining = res.date_mining;
                    this.count_mining = res.count_mining;
                    this.count_chucheon = res.count_chucheon;
                    this.sum_chucheon = res.sum_chucheon;
                    this.conversion_rate = res.conversion_rate;
                    this.chart = res.chart;
                    this.link = res.link;
                    this.rank = res.rank;
                    this.roulette = res.roulette;
                    this._setAppellation(res.appellation);
                    if (res.active_first != undefined) {
                        this.activeHasHistory = (res.active_first == 'N');
                    }
                    this.activePopup = (res.active_popup != undefined) ? res.active_popup : '';
                    this.activeDeposit = res.active_deposit || {};
                    //// 확정된 이름은 평평한 두 필드다. 먼저 제안했던 active_deposit
                    //// 묶음이 같이 오더라도 이쪽 값을 우선한다.
                    if (res.active_popup_address) {
                        this.activeDeposit.address = res.active_popup_address;
                    }
                    if (res.active_popup_amount != undefined && res.active_popup_amount !== '') {
                        this.activeDeposit.amount = res.active_popup_amount;
                    }
                    // this.bonus = res.bonus;
                    // this.balance_point = this.balance.point;    
                    // var parts = balance_point.toString().split(".");
                    // this.balance_point_parts01 = parts[0];
                    // this.balance_point_parts02 = parts[1];

                    // if (res.member != undefined) {   
                    //     this.member = res.member;
                    // }

                    // if (res.chucheon != undefined) {   
                    //     this.chucheon = res.chucheon;
                    // }

                    if (res.notice != undefined) {   
                        this.notice = res.notice;
                    }

                    if (res.banner != undefined) {   
                        this.banner = res.banner;
                    }
                    this.badges = res.badges;

                    resolve(res.chart);

                    // this.notice = res.notice;
                    // loader.dismiss();

                } else if(res.result ==="LOGOUT"){
                    // loader.dismiss();
                    let alert = this.alertCtrl.create({
                        message: res.message,
                        buttons: ['OK']
                    });
                    alert.present();
                    localStorage.removeItem("loginId");
                    localStorage.removeItem("api_key");

                    this.app.getRootNav().setRoot(LoginPage);
                
                } else {
                    // loader.dismiss();
                    let alert = this.alertCtrl.create({
                        message: res.message,
                        buttons: ['OK']
                    });
                    alert.present();
                }
            },(err)=>{
                // loader.dismiss();
                //// HTTP 에러인 경우
                let alert = this.alertCtrl.create({
                    message: this.texts.alertM_err,
                    buttons: ['OK']
                });
                alert.present();
            
            });
        });
	}

    // _bonus_progress() {
    //     this.max = [];
    //     this.min = [];
    //     this.cha = [];

    //     let url = "bonus/progress";
	// 	let body = JSON.stringify({ 
	// 		api: this.api_key,
    //         language: this.language,
    //         version: this.version
	// 	});
	// 	this.http.post(url, body).then((res: any) => {
	// 		if(res.result=="OK"){ 
    //             this.max = res.max;
	// 			this.min = res.min;
	// 			this.cha = res.cha;

    //             let max_value: any;
    //             let half_value: any;
    //             max_value = res.max.value.replace(/[^0-9]/g, "");
                
    //             half_value = max_value / 2;
    //             half_value = String(half_value);

    //             this.half_value = half_value.replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
                
                
	// 		} else if(res.result ==="LOGOUT"){
	// 			let alert = this.alertCtrl.create({
	// 				message: res.message,
	// 				buttons: ['OK']
	// 			});
	// 			alert.present();
			
	// 		} else {
	// 			let alert = this.alertCtrl.create({
	// 				message: res.message,
	// 				buttons: ['OK']
	// 			});
	// 			alert.present();
	// 		}
	// 	},(err)=>{	
	// 		//// HTTP 에러인 경우
	// 		let alert = this.alertCtrl.create({
	// 			message: this.texts.alertM_err,
	// 			buttons: ['OK']
	// 		});
	// 		alert.present();
		
	// 	});
    // }

    // ===== 2026-09-18 PDF p.2~3 : 입금액에 따른 회원 명칭 배지 =====

    /// config/dashboard 의 appellation 값을 배지 이미지 경로로 바꾼다.
    /// 필드가 없거나(구 서버) 표에 없는 값이면 '' 로 둬서 배지를 안 그린다.
    _setAppellation(value) {
        this.appellation = (value != undefined && value != null) ? ('' + value).trim() : '';
        this.appellationImg = WalletPage.APPELLATION_IMGS[this.appellation.toUpperCase()] || '';
    }

    // ===== 2026-08-26 PDF p.4~9 : 로그인 후 Active 안내 팝업 =====

    /// config/dashboard 의 active_popup 값에 따라 팝업을 띄운다.
    /// 'N'/빈 값/모르는 값이면 아무것도 하지 않는다 - 서버가 필드를 아직 안 보내는
    /// 동안에도 기존 동작이 그대로 유지되도록 한 안전 기본값이다.
    _active_popup() {
        if (this.activePopupShown) return;

        let mode = '';
        if (this.activePopup == 'A' || this.activePopup == 'D') {
            mode = 'apply';
        } else if (this.activePopup == 'R') {
            mode = 'renew';
        }
        if (mode == '') return;

        if (this._active_popup_hidden_today()) return;

        //// 로그인 1회당 한 번만 (탭을 오갈 때마다 다시 뜨지 않게)
        this.activePopupShown = true;

        let modal = this.modalCtrl.create(ActivepopupPage, { mode: mode });
        modal.present();
        modal.onDidDismiss((res: any) => {
            if (res == undefined || res == null) return;

            if (res.hideToday) {
                localStorage.setItem(this._active_popup_key(), this._active_popup_today());
            }

            if (res.action != 'cta') return;

            if (this.activePopup == 'A') {
                //// 차감 가능 - 바로 "신청" 확인 팝업 (PDF p.7)
                this._active_apply_confirm();
            } else {
                //// 차감 불가('D') / 갱신 실패('R') - 입금 팝업 (PDF p.8, p.9)
                this._active_deposit_popup();
            }
        });
    }

    _active_popup_key(): string {
        return 'active_popup_hide_' + (this.loginId || '');
    }

    _active_popup_today(): string {
        let d = new Date();
        let m = d.getMonth() + 1;
        let day = d.getDate();
        return d.getFullYear() + '-' + (m < 10 ? '0' + m : m) + '-' + (day < 10 ? '0' + day : day);
    }

    /// "오늘 하루 보지 않기" 를 오늘 날짜로 체크해뒀는지. 계정별로 따로 기억한다.
    _active_popup_hidden_today(): boolean {
        return localStorage.getItem(this._active_popup_key()) == this._active_popup_today();
    }

    _active_apply_confirm() {
        let modal = this.modalCtrl.create(ActiveconfirmPage, {
            message: this.activeTexts.active_msg_apply_notice
                || '신청 즉시 모든 Active 전용 혜택과 멤버십 특전이 시작됩니다.',
            confirmLabel: this.activeTexts.active_btn_popup_apply || '신청',
            cancelLabel: this.activeTexts.active_btn_popup_cancel || '취소'
        });
        modal.present();
        modal.onDidDismiss((confirmed) => {
            if (confirmed) {
                this._active_save();
            }
        });
    }

    _active_save() {
        let url = "active/base/index/save";
        let body = JSON.stringify({
            api: this.api_key,
            language: this.language,
            version: this.version,
            divide: 'A'
        });
        this.http.post(url, body).then((res: any) => {
            // result 값은 믿지 않는다. 2026-08-26 시점에는 성공해도 "NO" 가 오더니
            // 2026-08-29 실측에서는 "OK" 가 왔다(서버가 바꾼 듯하다). 어느 쪽이 오든
            // 실제 결과는 message 로만 구분 가능하므로 message 기준으로 안내한다
            // (myactive.ts:_save 의 같은 주석 참고).
            if (res.message) {
                let alert = this.alertCtrl.create({
                    message: res.message,
                    buttons: ['OK']
                });
                //// 안내를 읽은 뒤 My Active 로 넘긴다 (PDF p.7).
                alert.onDidDismiss(() => {
                    this.navCtrl.push(MyactivePage);
                });
                alert.present();
            } else {
                this.navCtrl.push(MyactivePage);
            }
        }, (err) => {
            let alert = this.alertCtrl.create({
                message: this.texts.alertM_err,
                buttons: ['OK']
            });
            alert.present();
        });
    }

    _active_deposit_popup() {
        let modal = this.modalCtrl.create(ActivedepositPage, { deposit: this.activeDeposit });
        modal.present();
    }

    _btn_event(event) {
        if (event == 'one' || event == 'two' || event == 'three' || event == 'four' || event == 'six') {
            this.navCtrl.push(BonuslistPage, {target: event, button: this.button});
        }

        if (event == 'funs') {
            this.navCtrl.push(AvatalistPage);
        }

        if (event == 'active') {
            this.navCtrl.push(MyactivePage);
        }

        if (event == 'bonus') {
            this.navCtrl.push(BonuslistPage);
        }

        if (event == "multi_add") {
            this.navCtrl.push(MultiregistPage);
        }
        
        if (event == "dbc_list") {
            this.navCtrl.push(DbclistPage);
        }

        if (event == 'register_address') {
            this.navCtrl.parent.select(2);
        }

        // if (event == 'withdrawal') {
        //     this.navCtrl.push(WithdrawalcoinlistPage);
        // }

        // if (event == 'setting') {
        //     this.navCtrl.push(MypagePage);
        // }
        
        if (event == 'chucheon_r') {
            this.navCtrl.push(MygroupPage);
        }

        if (event == 'ready') {
            let alert = this.alertCtrl.create({
                message: this.texts.alertM_ready,
                buttons: ['OK']
            });
            alert.present();
        }

        
    }

    _roulette_btn() {
        return new Promise((resolve,reject)=>{
            let url = "config/dashboard/index/roulette";
            let body = JSON.stringify({ 
                api: this.api_key,
                language: this.language,
                version: this.version
            });
            this.http.post(url, body).then((res: any) => {
                if(res.result=="OK"){
                    resolve(res.site);

                } else if(res.result ==="LOGOUT"){
                    let alert = this.alertCtrl.create({
                        message: res.message,
                        buttons: ['OK']
                    });
                    alert.present();
                    localStorage.removeItem("loginId");
                    localStorage.removeItem("api_key");
                    this.app.getRootNav().setRoot(LoginPage);
                
                } else {
                    let alert = this.alertCtrl.create({
                        message: res.message,
                        buttons: ['OK']
                    });
                    alert.present();
                }
            },(err)=>{	
                //// HTTP 에러인 경우
                let alert = this.alertCtrl.create({
                    message: this.texts.alertM_err,
                    buttons: ['OK']
                });
                alert.present();
            
            });
        });
    }

    _open_site(url) {
        const options = 'location=yes, hideurlbar=yes, zoom=no, clearcache=yes, clearsessioncache=yes';
        this.iab.create(url, '_system', options);
    }

    _inweb() {
        this._roulette_btn().then((res: any) => {
            const url = res;
            const options = 'location=yes, hideurlbar=yes, zoom=no, clearcache=yes, clearsessioncache=yes';
    
            const browser: InAppBrowserObject = this.iab.create(url, '_blank', options);

            setTimeout(() => {
                browser.on('exit').subscribe(event => {
                    this._init();
                });
                
            },500);
		});        
    }

    // _web_chucheon() {
    //     if (this.servermode == "Y"){
    //         this.chucheon_r_url = this.chucheon_base_url + this.api_key;
	// 	} else {
    //         this.chucheon_r_url = this.test_chucheon_base_url + this.api_key;
	// 	}
    // }

    // _web_line() {
    //     if (this.servermode == "Y"){
    //         this.chucheon_1_url = this.line_base_url + this.api_key;
	// 	} else {
    //         this.chucheon_1_url = this.test_line_base_url + this.api_key;
	// 	}
    // }

    // _line_event(line) {
    //     this.navCtrl.push(HuwonPage, {line: line});
    // }

    _chart_rate(chart) {
        Highcharts.setOptions({
        	lang:{
            	rangeSelectorZoom: '',
                thousandsSep: ',',
                numericSymbols: ['k', 'M', 'G', 'T', 'P', 'E']
            },
            global: {
                useUTC: false
            }
        });

        const barGradientA = {
            linearGradient: [0, 0, 0, 300],
            stops: [
                [0, 'rgb(174, 44, 241)'],
                [1, 'rgb(119, 118, 255)']
            ]
        };
        const barGradientB = {
            linearGradient: [0, 0, 0, 300],
            stops: [
                [0, 'rgb(2, 161, 249)'],
                [1, 'rgb(41, 241, 156)']
            ]
        };

        Highcharts.chart('chart_rate', {

            chart: {
                height: 150,
                type: 'column',
                backgroundColor: 'transparent'
            },
            title: {
                text: null
            },
            exporting: {
                enabled: false
            },
            credits: {
                enabled: false
            },
            legend: {
                enabled: false
            },
            yAxis: {
                visible: false
            },
            xAxis: {
                type: 'datetime',
                lineColor: 'rgba(255, 255, 255, 0.15)',
                labels: {
                    format: '{value:%d}',
                    style: {
                        color: '#a592f8',
                        fontWeight: 'bold'
                    }
                },
                tickInterval: 1 * 24 * 3600 * 1000 // 하루 간격으로 표시
            },
            tooltip: {
                format: '{value:,.0f}',
                dateTimeLabelFormats: '{value:%Y-%m-%d}',
                followPointer: false,
                outside: true,
                style: {
                    zIndex: 999
                }
            },
            plotOptions: {
                column: {
                    borderRadius: 6,
                    borderWidth: 0,
                    colorByPoint: true,
                    colors: [barGradientA, barGradientB],
                    pointPadding: 0.35,
                    groupPadding: 0.15
                }
            },
            series: [
                {
                showInLegend: false,
                name: 'Conversion Rate',
                data: chart
                }
            ]
        });
    }

    _deposit_event(item) {
        this.navCtrl.push(CountdownPage, {idx: item.idx});
    }
	
	_notifi(idx) {
        if (idx !== ''){
            this.navCtrl.push(NotifimodalPage, {idx: idx});
        } else {
            this.navCtrl.push(NotificationPage);
        }
	}

    _sanitize(vid) {
        return this.dom.bypassSecurityTrustResourceUrl(vid);
    }
}



// WEBPACK FOOTER //
// ./src/pages/wallet/wallet.ts